import React from 'react';
import {HomeSectionTitle, HomeSectionType} from "../../utils/common-styles";
import {HomeNewsItem} from "./HomeNewsItem";
import {NewsListContainer} from "../../utils/common-styles";

export const HomeNewsList = (props) => {

    return (
        <NewsListContainer>
            <HomeSectionTitle><strong>Our Latest   ____</strong></HomeSectionTitle>
            <HomeSectionType><h2>News Posts</h2></HomeSectionType>
            {props.posts.length > 0 && props.posts.map((newsItem, index) => {
                return <HomeNewsItem key={index} newsItem={newsItem} />
            })}
        </NewsListContainer>
    );
};